module.exports = __webpack_public_path__ + "static/media/speakers3.bd26e8f1.jpg";